import React, { FC }             from 'react';
import {
  Formik,
  Form,
  FormikProps,
  FieldArray,
}                                from 'formik';
import styled                    from 'styled-components';
import { DataTable }             from '@components/DataTable/DataTable';
import { TDataTableRow }         from '@typings/components';
import { ITaxesValues }          from '@typings/invoiceManagement';
import { Button }                from '@components/Button/Button';
import { taxesSchema }           from '@modules/invoiceManagement/utils/validation';
import { USE_TAX_TABLE_HEADERS } from '../utils/tableHeaders';

const Wrapper = styled.div`
  && {
    td {
      font-size: 15px;

      div {
        width: 125px;
      }
    }
  }
`;

const StyledForm = styled(Form)`
  display: flex;
`;

const TableWrapper = styled.div`
  width: 400px;
`;

const ActionWrapper = styled.div`
  width      : 400px;
  margin-top : 75px;
`;

interface IProps {
  initialValues : ITaxesValues;
  rows          : TDataTableRow[];
  handleSubmit  : (values: ITaxesValues) => Promise<void>;
  isLoading     : boolean;
}

export const UseTaxPage: FC<IProps> = ({
  initialValues,
  rows,
  handleSubmit,
  isLoading,
}) => (
  <Wrapper>
    <Formik
      initialValues    = {initialValues}
      onSubmit         = {handleSubmit}
      validationSchema = {taxesSchema}
      enableReinitialize
    >
      {({
        dirty,
        isValid,
        isSubmitting,
        resetForm,
      }: FormikProps<ITaxesValues>): JSX.Element => (
        <StyledForm>
          <TableWrapper>
            <FieldArray
              name   = "taxes"
              render = {() => (
                <DataTable
                  headers   = {USE_TAX_TABLE_HEADERS}
                  rows      = {rows}
                  loading   = {isLoading}
                  maxwidth  = "340px"
                  rowheight = "40px"
                />
              )}
            />
          </TableWrapper>

          <ActionWrapper>
            <Button
              label   = "Cancel"
              width   = "250px"
              variant = "outlined"
              onClick = {(): void => resetForm()}
            />
            <Button
              width     = "250px"
              type      = "submit"
              label     = "Save Changes"
              isLoading = {isSubmitting}
              disabled  = {!isValid || !dirty || isLoading}
            />
          </ActionWrapper>
        </StyledForm>
      )}
    </Formik>
  </Wrapper>
);
